import TeaserCard from "../shared/teaser-card/index.vue";
import TeamCard from "../shared/team-card/index.vue";
import ProjectCard from "../shared/project-card/index.vue";

export default {
  name: 'homepage',
  components: {
    TeaserCard,
    TeamCard,
    ProjectCard
  },
  props: [],
  data() {
    return {}
  },
  computed: {
    projects() {
      return this.$store.state.projects
    },
    services() {
      return this.$store.state.services
    },
    people() {
      return this.$store.state.people
    }
  },
  mounted() {},
  methods: {}
}